import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const SectionShell = ({ id, dark = false, className = "", style = {}, noAnimate = false, children, ...props }) => {
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "center center"],
  });

  const y = useTransform(scrollYProgress, [0, 1], [120, 0]);

  return (
    <section
      ref={ref}
      id={id}
      className={`${className} py-16`}
      style={{
        backgroundColor: dark ? "var(--color-brand-black)" : "var(--color-brand-white)",
        color: dark ? "var(--color-brand-white)" : "var(--color-brand-black)",
        ...style,
      }}
      {...props}
    >
      <motion.div
        className="mx-auto w-full max-w-6xl"
        style={{
          paddingLeft: "var(--section-padding-x)",
          paddingRight: "var(--section-padding-x)",
          ...(noAnimate ? {} : { y }),
        }}
      >
        {children}
      </motion.div>
    </section>
  );
};

